import { request } from '@/utils/request'

/**
 * 获取考试介绍详情
 */
export function getExamIntroduction(params) {
  return request(
    {
      url: `examIntroduction/type`,
      method: 'get',
      params: params
    },
    params
  )
}

/* 获取考试列表 */
// export function getExamList(params) {
//   return request({
//     url: `/exam/examType/${params.examType}/${params.userId}`,
//     method: 'get',
//     params: {}
//   })
// }
export function getExamList(params) {
  return request({
    url: `exam/${params.pageNum}/${params.pageSize}`,
    method: 'post',
    data: params.condition
  })
}
/* 考试报名 */
export function register(params) {
  return request({
    url: `/examUser`,
    method: 'post',
    data: params
  })
}
/**
 * 考试报名回显的字段
 */
export function getExamCustom(examId) {
  return request({
    url: `/exam-setting/exam/${examId}`,
    method: 'get'
  })
}
//考生报名设置显示字段
export function setExamCustom(params) {
  return request({
    url: `/exam-setting/addBatch`,
    method: 'post',
    data: params
  })
}
/**
 * 报名时获取考生信息
 */
export function getStudentInfo(userId) {
  return request({
    url: `/exam-user-base/${userId}`,
    method: 'get'
  })
}
/**
 * 报名时获取考生详情
 */
export function getStudentDetail(userId) {
  return request({
    url: `/examUser/${userId}`,
    method: 'get'
  })
}

//考生填写好个人信息提交确定
export function submitPersonInfo(params) {
  return request({
    url: `/examUser/signup`,
    method: 'post',
    data: params
  })
}
//查看是否报名
export function checkedSigup(params) {
  return request({
    url: '/examUser/queryAllSignedExams',
    method: 'post',
    data: params
  })
}
// 根据考试查询考试科目
export function getSubjectByExamId(examId) {
  return request({
    url: `/exam-detail/exam/${examId}`,
    method: 'get'
  })
}
